angular.module('impactx.comments').controller('CommentCtrl', [
    '$scope',
    'dataGen',
    '$timeout',
    '$securityManager',
    'FileHelperService',
    'TranslationService',
    '$config',
    'ConfirmationService',
    CommentController
]);

function CommentController($scope, dataGen, $timeout, $securityManager, FileHelperService, TranslationService, $config,
                           ConfirmationService) {
    var ctrl = this;
    ctrl.trns = {
        ctrlEnterApply: TranslationService.get('ctrlEnterApply'),
        asDelegationOf: TranslationService.get('asDelegationOf')
    };

    /**
     * Clears the last comment input.
     */
    $scope.clearLastComment = function () {
        $scope.commentDto.newCommentInput.value = "";
    };

    this.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };

    this.handleFile = function (evt, file) {
        if (file) {
            if (!FileHelperService.checkAllowedFileWithError(file.name)) {
                return;
            }
            $scope.$evalAsync(function () {
                ctrl.addAttachmentStream(file);
            });
        }
    };

    this.fileSelect = function () {
        $timeout(function () {
            angular.element(document.querySelector('#fileInput' + ($scope.commentDto.commentToken.replace(/([.])/g, '\\$1')))).click();
        });
    };

    $scope.isAddingAttachmentsCurrentlyAllowed = function () {
        return !$scope.commentDto.newBaseObject;
    };

    $scope.isAddingCommentsCurrentlyAllowed = function () {
        return !$scope.commentDto.newBaseObject;
    };

    this.addAttachmentStream = function (file) {
        var newComment = {};

        if ($scope.isAddingAttachmentsCurrentlyAllowed()) {
            var commentFormData = {
                file: file,
                fileName: file.name,
                commentToken: $scope.commentDto.commentToken,
                commentTokenData: $scope.commentDto.commentTokenData ? JSON.stringify($scope.commentDto.commentTokenData) : null
            };

            dataGen.uploadFile(commentFormData, $scope.useCommentTable ? '/comment/addattachmentstream/cmmnt' : '/comment/addattachmentstream').then(function (response) {
                $scope.commentDto.comments = response.data.comments;
                $scope.commentDto.readOnly = response.data.readOnly;
                checkAttachmentRequired();

                if (angular.isFunction($scope.onAttachmentAdded)) {
                    $scope.onAttachmentAdded();
                }
            }, angular.noop);
        }
        else {
            var newFile = {};
            if (file) {
                newFile.fileName = file.name;
                newFile.file = file;
            }

            newComment.comment = newFile.fileName;
            newComment.attachments = {
                newEntries: []
            };
            newComment.attachments.newEntries.push(newFile);
            if (!$scope.commentDto.newComments) {
                $scope.commentDto.newComments = [];
            }
            $scope.commentDto.newComments.push(newComment);

            $scope.clearLastComment();
            checkAttachmentRequired();
        }
    };

    $scope.addComment = function () {
        var dataObj,
            newComment = {},
            newCommentScope = {};

        if ($scope.isAddingCommentsCurrentlyAllowed()) {
            dataObj = {
                commentToken: $scope.commentDto.commentToken,
                commentTokenData: $scope.commentDto.commentTokenData,
                newComment: $scope.commentDto.newCommentInput.value
            };

            dataGen.postAsForm(newCommentScope, dataObj, $scope.useCommentTable ? "/comment/add/cmmnt" : "/comment/add").then(function () {
                $scope.commentDto.newCommentInput.value = "";
                $scope.commentDto.comments = newCommentScope.data.comments;
                $scope.commentDto.readOnly = newCommentScope.data.readOnly;
                checkAttachmentRequired();

                if (angular.isFunction($scope.onCommentAdded)) {
                    $scope.onCommentAdded();
                }
            });
        }
        else {
            //Here: pure frontend saving of comments
            newComment.comment = $scope.commentDto.newCommentInput.value;
            $scope.commentDto.newComments.push(newComment);

            $scope.clearLastComment();
        }
    };

    function checkAttachmentRequired() {
        if (impactX.isDefined($scope, "commentDto.attachmentsAllowed")) {
            if (($scope.attachmentRequired) ||
                ($scope.commentDto.attachmentRequired && $scope.commentDto.attachmentRequired.value)) {
                $scope.needAttachments = true;
                if ($scope.commentDto.newComments && $scope.commentDto.newComments.length > 0) {
                    angular.forEach($scope.commentDto.newComments, function (comment) {
                        if (impactX.isDefined(comment, 'attachments.newEntries.length') > 0) {
                            $scope.needAttachments = false;
                        }
                        if (impactX.isDefined(comment, 'attachments.existingEntries.length') > 0) {
                            $scope.needAttachments = false;
                        }
                    });
                }

                if ($scope.needAttachments) {
                    angular.forEach($scope.commentDto.comments, function (comment) {
                        if (impactX.isDefined(comment, 'attachments.newEntries.length') > 0) {
                            $scope.needAttachments = false;
                        }
                        if (impactX.isDefined(comment, 'attachments.existingEntries.length') > 0) {
                            $scope.needAttachments = false;
                        }
                    });
                }
            }
            else {
                $scope.needAttachments = false;
            }
            if ($scope.commentDto.attachmentRequiredNoValidation && $scope.commentDto.attachmentRequiredNoValidation.value) {
                $scope.needAttachmentRequiredNoValidation = true;
                if ($scope.commentDto.newComments && $scope.commentDto.newComments.length > 0) {
                    angular.forEach($scope.commentDto.newComments, function (comment) {
                        if (impactX.isDefined(comment, 'attachments.newEntries.length') > 0) {
                            $scope.needAttachmentRequiredNoValidation = false;
                        }
                        if (impactX.isDefined(comment, 'attachments.existingEntries.length') > 0) {
                            $scope.needAttachmentRequiredNoValidation = false;
                        }
                    });
                }

                if ($scope.needAttachmentRequiredNoValidation) {
                    angular.forEach($scope.commentDto.comments, function (comment) {
                        if (impactX.isDefined(comment, 'attachments.newEntries.length') > 0) {
                            $scope.needAttachmentRequiredNoValidation = false;
                        }
                        if (impactX.isDefined(comment, 'attachments.existingEntries.length') > 0) {
                            $scope.needAttachmentRequiredNoValidation = false;
                        }
                    });
                }
            }
            else {
                $scope.needAttachmentRequiredNoValidation = false;
            }
        }
        else {
            $scope.needAttachments = false;
        }
    }

    $scope.checkAttachmentRequired = function () {
        checkAttachmentRequired();
    };

    $scope.deleteNewCommentFinal = function (event, index) {
        $scope.commentDto.newComments.splice(index, 1);
        checkAttachmentRequired();
    };

    $scope.deleteNewComment = function (index, event) {
        var comment = $scope.commentDto.newComments[index];
        ConfirmationService.showConfirmationDialog($scope.deleteNewCommentFinal, event,
            comment.attachments && comment.attachments.newEntries && comment.attachments.newEntries.length > 0 ?
                TranslationService.get('confirmDeleteAttachment') : TranslationService.get('confirmDeleteComment'),
            TranslationService.get('delete'), TranslationService.get('abort'), null, index);
    };

    $scope.deleteComment = function (comment, event) {
        ConfirmationService.showConfirmationDialog($scope.deleteCommentFinal, event,
            comment.attachments && comment.attachments.existingEntries && comment.attachments.existingEntries.length > 0 ?
                TranslationService.get('confirmDeleteAttachment') : TranslationService.get('confirmDeleteComment'),
            TranslationService.get('delete'), TranslationService.get('abort'), null, comment);
    };

    $scope.deleteCommentFinal = function (event, comment) {
        var dataObj;
        var newCommentScope = {};

        if (!$scope.commentDto.newBaseObject) {
            dataObj = {
                commentToken: $scope.commentDto.commentToken,
                commentTokenData: $scope.commentDto.commentTokenData,
                index: comment.index
            };

            dataGen.postAsForm(newCommentScope, dataObj, $scope.useCommentTable ? "/comment/delete/cmmnt" : "/comment/delete").then(function () {
                $scope.commentDto.comments = newCommentScope.data.comments;
                $scope.commentDto.readOnly = newCommentScope.data.readOnly;
                checkAttachmentRequired();
                if (angular.isFunction($scope.onCommentDeleted)) {
                    $scope.onCommentDeleted();
                }
            });
        }
        else {
            $scope.commentDto.comments.splice(comment.index, 1);
            checkAttachmentRequired();
        }
    };

    $scope.handleShortcut = function (event, message) {
        if (event && message) {
            if (event.ctrlKey && event.keyCode == 13) {
                $scope.addComment();
            }
        }
    };

    $scope.downloadFile = function (attachment) {
        if (attachment && attachment.file && attachment.fileName) {
            var form = document.createElement('form');
            form.action = $config.sourceURL + "/comment/download/file";
            form.method = 'POST';
            form.target = '_blank';
            form.style.display = 'none';

            var token = document.createElement('input');
            token.type = 'text';
            token.name = 'token';
            token.value = $securityManager.getToken();

            var fileInput = document.createElement('input');
            fileInput.name = 'file';
            fileInput.value = attachment.file;

            var fileNameInput = document.createElement('input');
            fileNameInput.name = 'fileName';
            fileNameInput.value = attachment.fileName;

            var submit = document.createElement('input');
            submit.type = 'submit';
            submit.id = 'submitForm';

            form.appendChild(token);
            form.appendChild(fileInput);
            form.appendChild(fileNameInput);
            form.appendChild(submit);
            document.body.appendChild(form);

            $('#submitForm').click();

            document.body.removeChild(form);
        }
    }
}